import project from '../../package.json'
/**
 * localStorage
 * @param key localStorage key 值
 * @returns value 值
 */
class LocalStorage {
  set (key, value) {
    localStorage.setItem(project.name + '-' + key, value)
  }
  get (key) {
    return localStorage.getItem(project.name + '-' + key) || ''
  }
  remove (key) {
    localStorage.removeItem(project.name + '-' + key)
  }
  clear () {
    localStorage.clear()
  }
}
export default new LocalStorage()
